export const MAGIC_COMMENT_VERSION = "0.1.14";
